const decodeBase64Url = (base64Url) => {
  const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
  const binary = atob(base64);
  const bytes = Uint8Array.from(binary, (char) => char.charCodeAt(0));
  return new TextDecoder('utf-8').decode(bytes);
};

export const parseJwtPayload = (token) => {
  if (!token) return null;

  try {
    const payload = token.split('.')[1];
    return JSON.parse(decodeBase64Url(payload));
  } catch {
    return null;
  }
};

export const getUserFromToken = (token) => {
  const payload = parseJwtPayload(token);
  return payload?.userDto ?? null;
};

export const isAccessTokenExpired = (token) => {
  const payload = parseJwtPayload(token);
  if (!payload?.exp) {
    return true;
  }

  return Date.now() >= payload.exp * 1000;
};
